// extracted by mini-css-extract-plugin
export var menu = "NavItem-module--menu--3Rncr";
export var nav_list_item = "NavItem-module--nav_list_item--WUuxK";
export var visible = "NavItem-module--visible--DY-Do";